var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "version": "1.0",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "512.000000pt",
      "height": "512.000000pt",
      "viewBox": "0 0 512.000000 512.000000",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
      "stroke": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1761 5106 c-46 -25 -50 -48 -51 -253 l0 -191 -131 -4 c-129 -3 -131\n-3 -155 -31 l-24 -28 0 -979 0 -979 -296 -3 -296 -3 -29 -33 -29 -32 0 -1185\n0 -1185 -145 0 c-107 0 -153 -4 -174 -14 -29 -15 -51 -53 -51 -87 0 -30 30\n-76 57 -88 17 -8 637 -11 2129 -11 l2106 0 34 34 c38 38 43 72 17 116 -22 37\n-52 50 -118 50 l-55 0 -2 1531 -3 1531 -33 29 -32 29 -340 0 -340 0 0 613 c0\n388 -4 626 -10 649 -19 67 -45 78 -186 78 l-124 0 0 196 c0 115 -4 203 -10\n215 -27 50 -10 49 -877 49 -651 -1 -813 -3 -832 -14z m1519 -316 l0 -130 -685\n0 -685 0 0 130 0 130 685 0 685 0 0 -130z m310 -2460 l0 -2130 -245 0 -244 0\n-3 351 -3 351 -33 29 -32 29 -425 0 c-245 0 -434 -4 -449 -10 -14 -5 -33 -21\n-43 -37 -16 -24 -18 -60 -21 -370 l-3 -343 -244 0 -245 0 0 2130 0 2130 995 0\n995 0 0 -2130z m760 -670 l0 -1460 -275 0 -275 0 0 1460 0 1460 275 0 275 0 0\n-1460z m-2952 -342 l2 -1118 -225 0 -225 0 0 1120 0 1120 223 -2 222 -3 3\n-1117z m1502 -838 l0 -280 -300 0 -300 0 0 280 0 280 300 0 300 0 0 -280z"
    }
  }), _c('path', {
    attrs: {
      "d": "M1862 4100 c-18 -11 -37 -32 -42 -46 -6 -14 -10 -135 -10 -270 0\n-260 5 -290 49 -314 12 -6 123 -10 286 -10 l267 0 29 29 29 29 0 261 c0 173\n-4 268 -11 285 -23 50 -55 56 -321 56 -225 0 -245 -2 -276 -20z m408 -310 l0\n-130 -130 0 -130 0 0 130 0 130 130 0 130 0 0 -130z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2784 4110 c-12 -4 -31 -21 -43 -36 -20 -26 -21 -36 -21 -291 l0\n-265 29 -29 29 -29 271 0 270 0 28 24 28 24 3 270 3 271 -30 33 -29 33 -259 2\nc-142 1 -268 -2 -279 -7z m396 -320 l0 -130 -130 0 -130 0 0 130 0 130 130 0\n130 0 0 -130z"
    }
  }), _c('path', {
    attrs: {
      "d": "M1848 3071 l-33 -29 0 -272 0 -272 33 -29 33 -30 271 3 270 3 24 28\n24 28 0 270 0 271 -29 29 -29 29 -266 0 -266 0 -32 -29z m422 -301 l0 -130\n-130 0 -130 0 0 130 0 130 130 0 130 0 0 -130z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2771 3086 c-47 -26 -50 -44 -51 -314 0 -275 4 -297 55 -320 40 -19\n517 -17 554 2 47 25 51 47 51 316 0 269 -4 291 -51 316 -39 20 -522 20 -558 0z\nm409 -316 l0 -130 -130 0 -130 0 0 130 0 130 130 0 130 0 0 -130z"
    }
  }), _c('path', {
    attrs: {
      "d": "M1882 2079 c-20 -6 -40 -22 -52 -42 -18 -30 -20 -51 -20 -282 0 -357\n-20 -338 358 -333 l244 3 29 33 29 32 0 265 0 265 -29 32 -29 33 -249 2 c-139\n1 -262 -2 -281 -8z m388 -324 l0 -136 -127 3 -128 3 -3 119 c-1 66 0 126 2\n133 4 10 37 13 131 13 l125 0 0 -135z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2793 2079 c-17 -5 -41 -21 -52 -35 -20 -25 -21 -39 -21 -290 l0\n-264 29 -32 29 -33 272 0 272 0 29 33 29 32 0 264 c0 250 -1 265 -20 289 -12\n15 -38 31 -58 37 -46 12 -465 12 -509 -1z m387 -324 l0 -135 -130 0 -130 0 0\n135 0 135 130 0 130 0 0 -135z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }